import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=6764ce0f&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=ts&"
export * from "./Dashboard.vue?vue&type=script&lang=ts&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=6764ce0f&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6764ce0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6764ce0f')) {
      api.createRecord('6764ce0f', component.options)
    } else {
      api.reload('6764ce0f', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=6764ce0f&scoped=true&", function () {
      api.rerender('6764ce0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/Dashboard.vue"
export default component.exports